import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { States } from '@app/shared/__generated__/states-graphql.service.types';
import { StatesGraphQLService } from '@app/shared/states-graphql.service';

export type State = Omit<States['states'][0], '__typename'>;

@Injectable()
export class StateService {
  states$: Observable<State[]>;

  constructor(private statesGraphQLService: StatesGraphQLService) {
    this.states$ = this.statesGraphQLService.fetch().pipe(
      map(result => result.data.states),
      shareReplay(1),
    );
  }
}
